export default __webpack_public_path__ + "static/media/logo.f50b8f2e.png";